export default __webpack_public_path__ + "images/9ebdca314d7328387051912626269347.svg";